module.exports = __webpack_public_path__ + "static/11-b5bb14a9998700b774732e6823c546d5.png";